// extracted by mini-css-extract-plugin
module.exports = {"showPopup":"Popup_showPopup__2AhxJ","hed":"Popup_hed__3yR4C","xIcon":"Popup_xIcon__q3Kvu","content":"Popup_content__2Lqtg"};